<div class="chat-car-details" [class.chat-car-details--locked]="locked">
  @if (locked && chosenSummary) {
    <div class="chat-car-details__chosen">{{ chosenSummary }}</div>
  } @else {
    <label class="chat-car-details__field">
      <span i18n="@@carColour">Car Colour</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="carColour"
        pattern="[A-Za-z ]+"
        placeholder="e.g. red"
        title="Enter the colour of the car"
      />
    </label>
    <label class="chat-car-details__field">
      <span i18n="@@carMake">Car Make</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="carMake"
        pattern="[A-Za-z ]+"
        placeholder="e.g. Ford"
        title="Enter the make of the car"
      />
    </label>
    <label class="chat-car-details__field">
      <span i18n="@@carModel">Car Model</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="carModel"
        pattern="[A-Za-z0-9 ]+"
        placeholder="e.g. Escort"
        title="Enter the model of the car"
      />
    </label>
    <label class="chat-car-details__field">
      <span i18n="@@registration">Registration</span>
      <input
        type="text"
        autocomplete="off"
        [disabled]="locked"
        [(ngModel)]="registration"
        pattern="[A-Za-z0-9 ]+"
        placeholder="e.g. ABF1 3EG"
        title="Enter the registration of the car"
      />
    </label>
    <div class="chat-car-details__actions">
      @if (!required) {
        <button
          i18n="@@skip"
          type="button"
          class="chat-car-details__skip"
          [disabled]="locked"
          (click)="onSkip()"
        >
          Skip
        </button>
      }
      <button
        type="button"
        class="chat-car-details__continue"
        [disabled]="locked || !isValid"
        (click)="onContinue()"
        i18n="@@continue"
      >
        Continue
      </button>
    </div>
  }
</div>
